import actionTypes from '../constants/action-types';

const setPageTemplates = (pageTemplates) => ({
  type: actionTypes.SET_PAGE_TEMPLATES,
  payload: {
    pageTemplates,
  },
});

export default setPageTemplates;
